// Logo URLs
export const logoUrl =
  "https://storage.helloreaddy.io/project_files/e177d077-e469-49ee-9ac2-a791f255c4a8/cb9e6b07-45c1-42a9-bb20-6b90e6680fd3_compressed_Asset-54x.webp";

export const logoUrlLight =
  "https://storage.helloreaddy.io/project_files/e177d077-e469-49ee-9ac2-a791f255c4a8/cb9e6b07-45c1-42a9-bb20-6b90e6680fd3_compressed_Asset-54x.webp";

// ===== ASTROJAL BRAND GRADIENT =====
export const astrojalGradient = "linear-gradient(135deg, #2563EB 0%, #7C3AED 50%, #F97316 100%)";
export const astrojalGradientText = "bg-gradient-to-r from-[#2563EB] via-[#7C3AED] to-[#F97316]";

export const heroData = {
  badge: "Laravel \u2022 PHP \u2022 SaaS \u2022 API \u2022 Cloud \u2022 AI",
  headline: "Laravel Experts Building Scalable Digital Products",
  highlightWords: "Laravel Experts",
  subtext:
    "We design and develop high-performance web applications, APIs, SaaS platforms and custom software using Laravel, PHP and modern technologies.",
  primaryCTA: "Start Your Project",
  secondaryCTA: "View Our Work",
  trustLine: "Trusted by startups, businesses and growing enterprises",
  techLine: "Laravel \u2022 PHP \u2022 APIs \u2022 SaaS \u2022 Flutter \u2022 AWS",
};

// ===== CORE TECHNOLOGY TRUST STRIP =====
export const techTrustStripData = {
  heading: "Core Technology Expertise",
  items: [
    { name: "Laravel", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/laravel/laravel-original.svg", featured: true },
    { name: "PHP", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/php/php-original.svg", featured: false },
    { name: "Vue.js", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/vuejs/vuejs-original.svg", featured: false },
    { name: "Flutter", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/flutter/flutter-original.svg", featured: false },
    { name: "AWS", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/amazonwebservices/amazonwebservices-original-wordmark.svg", featured: false },
    { name: "AI", logo: "", featured: false, isCustom: true, icon: "ri-bard-line", color: "text-accent-500" },
  ],
};

// ===== VISUAL SLIDER DATA =====
export const visualSliderData = {
  slides: [
    {
      title: "Build. Scale. Transform.",
      text: "Modern software solutions engineered around your business goals.",
      cta: "Explore Our Services",
      ctaHref: "#services",
      image: "https://readdy.ai/api/search-image?query=Modern%20SaaS%20dashboard%20UI%20mockup%20with%20blue%20and%20purple%20gradient%20lighting%2C%20data%20visualization%20charts%2C%20clean%20minimal%20interface%20design%2C%203D%20floating%20cards%20with%20glassmorphism%20effect%2C%20premium%20software%20design%2C%20no%20text%2C%20professional%20tech%20aesthetic&width=1400&height=800&seq=astrojal-slider-1&orientation=landscape",
    },
    {
      title: "Laravel Engineering at Scale",
      text: "High-performance Laravel applications, APIs and enterprise systems built for growth.",
      cta: "Explore Laravel Development",
      ctaHref: "/services/laravel-development",
      image: "https://readdy.ai/api/search-image?query=Laravel%20backend%20architecture%20visualization%2C%20abstract%203D%20code%20structure%20diagram%20with%20blue%20and%20purple%20glow%2C%20API%20endpoints%20and%20database%20connections%2C%20modern%20tech%20aesthetic%2C%20floating%20geometric%20shapes%2C%20premium%20software%20engineering%20visual%2C%20no%20text&width=1400&height=800&seq=astrojal-slider-2&orientation=landscape",
    },
    {
      title: "From Idea to Digital Product",
      text: "Turn your business requirements into reliable, scalable digital experiences.",
      cta: "Start Your Project",
      ctaHref: "#contact",
      image: "https://readdy.ai/api/search-image?query=Modern%20software%20product%20development%20UI%20mockup%2C%20mobile%20and%20web%20app%20screens%20floating%20in%203D%20space%2C%20blue%20and%20purple%20gradient%20background%2C%20clean%20minimal%20design%2C%20glassmorphism%20cards%2C%20premium%20digital%20product%20showcase%2C%20no%20text&width=1400&height=800&seq=astrojal-slider-3&orientation=landscape",
    },
    {
      title: "AI-Powered Digital Solutions",
      text: "Bring modern AI capabilities into your applications, workflows and SaaS products.",
      cta: "Explore AI Solutions",
      ctaHref: "/ai-solutions",
      image: "https://readdy.ai/api/search-image?query=AI%20artificial%20intelligence%20abstract%203D%20visualization%2C%20neural%20network%20nodes%20with%20blue%20and%20purple%20glow%2C%20modern%20cloud%20architecture%2C%20floating%20geometric%20shapes%2C%20data%20particles%2C%20premium%20tech%20aesthetic%2C%20gradient%20lighting%2C%20no%20text&width=1400&height=800&seq=astrojal-slider-4&orientation=landscape",
    },
  ],
};

// ===== CLIENT TRUST SLIDER DATA =====
export const clientTrustSliderData = {
  heading: "Trusted by Businesses Building for What's Next",
  items: [
    { name: "Technology", icon: "ri-cpu-line" },
    { name: "Healthcare", icon: "ri-heart-pulse-line" },
    { name: "FinTech", icon: "ri-bank-line" },
    { name: "E-commerce", icon: "ri-shopping-cart-line" },
    { name: "SaaS", icon: "ri-cloud-line" },
    { name: "Enterprise", icon: "ri-building-4-line" },
    { name: "Education", icon: "ri-graduation-cap-line" },
    { name: "Logistics", icon: "ri-truck-line" },
    { name: "Real Estate", icon: "ri-building-line" },
    { name: "Travel", icon: "ri-plane-line" },
  ],
};

// ===== BUSINESS IMPACT DATA =====
export const businessImpactData = {
  heading: "Technology That Delivers Business Impact",
  items: [
    {
      number: "01",
      title: "Scalable Products",
      desc: "Architecture designed to grow with your users and business.",
      icon: "ri-expand-diagonal-line",
      gradient: "from-[#2563EB] to-[#7C3AED]",
    },
    {
      number: "02",
      title: "Faster Performance",
      desc: "Optimized APIs, databases and infrastructure for better performance.",
      icon: "ri-flashlight-line",
      gradient: "from-[#7C3AED] to-[#F97316]",
    },
    {
      number: "03",
      title: "Reliable Engineering",
      desc: "Secure, maintainable and production-ready software.",
      icon: "ri-shield-check-line",
      gradient: "from-[#F97316] to-[#F59E0B]",
    },
    {
      number: "04",
      title: "Long-Term Partnership",
      desc: "Technology support that continues beyond launch.",
      icon: "ri-user-follow-line",
      gradient: "from-[#2563EB] to-[#F97316]",
    },
  ],
};

// ===== AWARDS & ACCOLADES DATA =====
export const awardsSectionData = {
  heading: "Awards & Accolades",
  subtext: "Recognized for excellence in software development and client delivery.",
  items: [
    {
      icon: "ri-award-line",
      title: "Industry Recognition",
      year: "2026",
      desc: "Acknowledged for outstanding software engineering practices.",
      color: "#2563EB",
    },
    {
      icon: "ri-trophy-line",
      title: "Technology Excellence",
      year: "2026",
      desc: "Awarded for innovative technology solutions and architecture.",
      color: "#7C3AED",
    },
    {
      icon: "ri-medal-line",
      title: "Client Excellence",
      year: "2026",
      desc: "Recognized for consistent client satisfaction and delivery.",
      color: "#F97316",
    },
    {
      icon: "ri-star-line",
      title: "Quality Standards",
      year: "2026",
      desc: "Committed to maintaining the highest quality in every project.",
      color: "#F59E0B",
    },
  ],
};

// ===== TRUST HIGHLIGHT DATA =====
export const trustHighlightData = {
  quote: "Clear communication, strong engineering and a product built exactly around our requirements.",
  name: "James Mitchell",
  position: "CTO",
  company: "ScaleFlow Inc.",
  rating: 5,
};

export const trustData = {
  heading: "Trusted Technology Partner for Growing Businesses",
  logos: [
    { name: "TechFlow", id: "t1" },
    { name: "DataSync", id: "t2" },
    { name: "CloudPeak", id: "t3" },
    { name: "NexGen", id: "t4" },
    { name: "ScaleUp", id: "t5" },
    { name: "AppWise", id: "t6" },
  ],
};

export const statsData = [
  { value: 10, suffix: "+", label: "Years of Experience" },
  { value: 100, suffix: "+", label: "Projects Delivered" },
  { value: 50, suffix: "+", label: "Happy Clients" },
  { value: 99, suffix: "%", label: "Client Satisfaction" },
];

export const servicesData = {
  heading: "Technology Expertise That Drives Business Growth",
  cta: "View All Services",
  items: [
    {
      title: "Laravel Development",
      desc: "Build secure, scalable and maintainable applications with experienced Laravel developers.",
      icon: "ri-code-s-slash-line",
      featured: true,
    },
    {
      title: "Web Application Development",
      desc: "Custom web applications designed around your business processes.",
      icon: "ri-window-line",
      featured: false,
    },
    {
      title: "API Development",
      desc: "Secure and scalable REST APIs and third-party integrations.",
      icon: "ri-exchange-line",
      featured: false,
    },
    {
      title: "SaaS Development",
      desc: "Multi-tenant SaaS platforms built for scale.",
      icon: "ri-cloud-line",
      featured: false,
    },
    {
      title: "AI Integration & Development",
      desc: "Integrate modern AI capabilities into web applications, SaaS platforms and business workflows using leading AI models and APIs.",
      icon: "ri-bard-line",
      featured: false,
    },
    {
      title: "Flutter App Development",
      desc: "Cross-platform mobile applications powered by robust Laravel APIs.",
      icon: "ri-smartphone-line",
      featured: false,
    },
    {
      title: "Cloud & DevOps",
      desc: "AWS, deployment, monitoring, scalability and performance.",
      icon: "ri-server-line",
      featured: false,
    },
    {
      title: "UI/UX Development",
      desc: "Modern responsive interfaces focused on usability and conversion.",
      icon: "ri-palette-line",
      featured: false,
    },
    {
      title: "Maintenance & Support",
      desc: "Long-term technical support, optimization and continuous improvements.",
      icon: "ri-tools-line",
      featured: false,
    },
  ],
};

export const laravelExpertiseData = {
  heading: "Laravel Expertise That Goes Beyond Code",
  desc: "From architecture and API development to database optimization and cloud deployment, we build Laravel applications designed for performance, security and scale.",
  cta: "Talk to a Laravel Expert",
  items: [
    "Laravel Architecture",
    "REST API",
    "AI API Integration",
    "Redis",
    "MySQL",
    "AWS",
    "Queue",
    "Cloudflare",
    "PHP",
    "Authentication",
    "Caching",
    "Testing",
    "Deployment",
  ],
};

export const whyChooseUsData = {
  heading: "Why Businesses Choose Us",
  items: [
    {
      title: "Laravel Expertise",
      desc: "Deep experience building production-ready Laravel applications.",
      icon: "ri-code-box-line",
    },
    {
      title: "Scalable Architecture",
      desc: "Systems designed to grow with your business.",
      icon: "ri-arrow-right-up-line",
    },
    {
      title: "Clean & Maintainable Code",
      desc: "Structured code designed for long-term maintenance.",
      icon: "ri-file-code-line",
    },
    {
      title: "Performance Focused",
      desc: "Fast APIs, optimized databases and efficient infrastructure.",
      icon: "ri-speed-line",
    },
    {
      title: "Transparent Communication",
      desc: "Clear communication and regular project updates.",
      icon: "ri-chat-3-line",
    },
    {
      title: "Long-Term Partnership",
      desc: "Continuous technical support after launch.",
      icon: "ri-heart-3-line",
    },
  ],
};

export const processData = {
  heading: "Our Proven Development Process",
  steps: [
    { number: "01", title: "Discovery", desc: "Understand business requirements and goals." },
    { number: "02", title: "Planning", desc: "Architecture, technology stack and roadmap." },
    { number: "03", title: "UI/UX", desc: "Design intuitive and modern interfaces." },
    { number: "04", title: "Development", desc: "Build secure and scalable software." },
    { number: "05", title: "Testing", desc: "Functional, security and performance testing." },
    { number: "06", title: "Deployment", desc: "Production deployment and infrastructure setup." },
    { number: "07", title: "Support", desc: "Maintenance and continuous optimization." },
  ],
};

export const techStackData = {
  heading: "Technologies We Work With",
  subtext:
    "Modern technologies, powerful frameworks and AI tools we use to build scalable digital products.",
  groups: [
    {
      name: "Backend",
      description: "Scalable backend technologies for secure and high-performance applications.",
      icon: "ri-server-line",
      items: [
        { name: "Laravel", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/laravel/laravel-original.svg", featured: true },
        { name: "PHP", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/php/php-original.svg", featured: false },
        { name: "Node.js", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/nodejs/nodejs-original.svg", featured: false },
      ],
    },
    {
      name: "Frontend",
      description: "Modern interfaces built for performance and usability.",
      icon: "ri-layout-masonry-line",
      items: [
        { name: "Vue.js", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/vuejs/vuejs-original.svg", featured: false },
        { name: "React", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/react/react-original.svg", featured: false },
        { name: "JavaScript", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/javascript/javascript-original.svg", featured: false },
        { name: "Tailwind CSS", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/tailwindcss/tailwindcss-original.svg", featured: false },
        { name: "HTML5", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/html5/html5-original.svg", featured: false },
        { name: "CSS3", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/css3/css3-original.svg", featured: false },
      ],
    },
    {
      name: "Mobile",
      description: "Cross-platform mobile experiences for iOS and Android.",
      icon: "ri-smartphone-line",
      items: [
        { name: "Flutter", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/flutter/flutter-original.svg", featured: false },
        { name: "Dart", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/dart/dart-original.svg", featured: false },
      ],
    },
    {
      name: "Database",
      description: "Reliable data infrastructure for scalable applications.",
      icon: "ri-database-2-line",
      items: [
        { name: "MySQL", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/mysql/mysql-original.svg", featured: false },
        { name: "PostgreSQL", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/postgresql/postgresql-original.svg", featured: false },
        { name: "Redis", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/redis/redis-original.svg", featured: false },
      ],
    },
    {
      name: "Cloud",
      description: "Cloud infrastructure built for security, performance and scale.",
      icon: "ri-cloud-line",
      items: [
        { name: "AWS", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/amazonwebservices/amazonwebservices-original-wordmark.svg", featured: false },
        { name: "Cloudflare", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/cloudflare/cloudflare-original.svg", featured: false },
        { name: "DigitalOcean", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/digitalocean/digitalocean-original.svg", featured: false },
      ],
    },
    {
      name: "DevOps",
      description: "Tools for deployment, automation, collaboration and reliability.",
      icon: "ri-ship-line",
      items: [
        { name: "Docker", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/docker/docker-original.svg", featured: false },
        { name: "Git", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/git/git-original.svg", featured: false },
        { name: "GitHub", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/github/github-original.svg", featured: false },
        { name: "CI/CD", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/githubactions/githubactions-original.svg", featured: false },
      ],
    },
    {
      name: "Tools & Others",
      description: "Tools that help us design, develop and manage products.",
      icon: "ri-tools-line",
      items: [
        { name: "Postman", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/postman/postman-original.svg", featured: false },
        { name: "Figma", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/figma/figma-original.svg", featured: false },
        { name: "Nginx", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/nginx/nginx-original.svg", featured: false },
        { name: "Jira", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/jira/jira-original.svg", featured: false },
        { name: "Slack", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/slack/slack-original.svg", featured: false },
        { name: "Trello", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/trello/trello-original.svg", featured: false },
      ],
    },
    {
      name: "AI & AI Development",
      description: "Modern AI tools and platforms powering intelligent digital products.",
      icon: "ri-bard-line",
      items: [
        { name: "ChatGPT", logo: "https://registry.npmmirror.com/@lobehub/icons-static-svg/latest/files/icons/openai.svg", featured: false },
        { name: "Claude", logo: "https://registry.npmmirror.com/@lobehub/icons-static-svg/latest/files/icons/claude-color.svg", featured: false },
        { name: "Antigravity", logo: "https://registry.npmmirror.com/@lobehub/icons-static-svg/latest/files/icons/antigravity-color.svg", featured: false },
        { name: "GitHub Copilot", logo: "https://registry.npmmirror.com/@lobehub/icons-static-svg/latest/files/icons/githubcopilot.svg", featured: false },
        { name: "Gemini", logo: "https://registry.npmmirror.com/@lobehub/icons-static-svg/latest/files/icons/gemini-color.svg", featured: false },
        { name: "Cursor", logo: "https://www.cursor.com/assets/images/logo.svg", featured: false },
        { name: "OpenAI Codex", logo: "https://registry.npmmirror.com/@lobehub/icons-static-svg/latest/files/icons/codex-color.svg", featured: false },
        { name: "Microsoft Copilot", logo: "https://registry.npmmirror.com/@lobehub/icons-static-svg/latest/files/icons/copilot-color.svg", featured: false },
      ],
    },
  ],
};

export const portfolioData = {
  heading: "Projects We've Built",
  cta: "View All Projects",
  items: [
    {
      title: "SaaS Platform",
      industry: "SaaS",
      tech: "Laravel, Vue.js, AWS",
      desc: "Multi-tenant subscription management platform with real-time analytics.",
      image:
        "https://readdy.ai/api/search-image?query=Modern%20SaaS%20dashboard%20UI%20mockup%20on%20dark%20background%2C%20clean%20analytics%20interface%2C%20data%20charts%2C%20subscription%20metrics%2C%20professional%20software%20design%2C%20no%20text%2C%20premium%20minimal%20style&width=800&height=600&seq=astrojal-portfolio-1&orientation=landscape",
    },
    {
      title: "Enterprise Management System",
      industry: "Enterprise",
      tech: "Laravel, React, PostgreSQL",
      desc: "End-to-end enterprise resource planning with custom workflows.",
      image:
        "https://readdy.ai/api/search-image?query=Enterprise%20management%20software%20dashboard%20UI%20mockup%20dark%20theme%2C%20workflow%20charts%2C%20data%20tables%2C%20professional%20business%20interface%2C%20modern%20clean%20design%2C%20no%20text%2C%20premium%20minimal%20style&width=800&height=600&seq=astrojal-portfolio-2&orientation=landscape",
    },
    {
      title: "E-commerce Platform",
      industry: "E-commerce",
      tech: "Laravel, Tailwind, MySQL",
      desc: "High-performance e-commerce with custom checkout and inventory management.",
      image:
        "https://readdy.ai/api/search-image?query=Modern%20e-commerce%20platform%20UI%20mockup%20dark%20theme%2C%20product%20grid%2C%20shopping%20cart%20interface%2C%20clean%20checkout%20design%2C%20professional%20web%20design%2C%20no%20text%2C%20premium%20minimal%20style&width=800&height=600&seq=astrojal-portfolio-3&orientation=landscape",
    },
    {
      title: "FinTech Application",
      industry: "FinTech",
      tech: "Laravel, React, AWS",
      desc: "Secure financial platform with real-time transaction processing.",
      image:
        "https://readdy.ai/api/search-image?query=FinTech%20financial%20dashboard%20UI%20mockup%20dark%20theme%2C%20transaction%20charts%2C%20secure%20banking%20interface%2C%20modern%20minimal%20design%2C%20no%20text%2C%20premium%20professional%20style&width=800&height=600&seq=astrojal-portfolio-4&orientation=landscape",
    },
    {
      title: "Healthcare Platform",
      industry: "Healthcare",
      tech: "Laravel, Flutter, PostgreSQL",
      desc: "HIPAA-compliant patient management with mobile companion app.",
      image:
        "https://readdy.ai/api/search-image?query=Healthcare%20medical%20dashboard%20UI%20mockup%20dark%20theme%2C%20patient%20records%20interface%2C%20medical%20charts%2C%20clean%20professional%20design%2C%20no%20text%2C%20premium%20minimal%20style&width=800&height=600&seq=astrojal-portfolio-5&orientation=landscape",
    },
    {
      title: "Mobile Application",
      industry: "Mobile",
      tech: "Flutter, Laravel API, Firebase",
      desc: "Cross-platform mobile app with real-time sync and offline support.",
      image:
        "https://readdy.ai/api/search-image?query=Mobile%20application%20UI%20mockup%20on%20dark%20background%2C%20smartphone%20screen%20displaying%20modern%20app%20interface%2C%20clean%20mobile%20design%2C%20professional%20app%20showcase%2C%20no%20text%2C%20premium%20minimal%20style&width=800&height=600&seq=astrojal-portfolio-6&orientation=landscape",
    },
    {
      title: "AI-Powered Business Platform",
      industry: "AI & SaaS",
      tech: "Laravel, PHP, REST API, OpenAI, Vue.js",
      desc: "An intelligent business platform integrating AI-powered workflows and automation for enterprise teams.",
      image:
        "https://readdy.ai/api/search-image?query=AI-powered%20business%20platform%20dashboard%20UI%20mockup%20dark%20theme%2C%20machine%20learning%20interface%2C%20intelligent%20automation%20panels%2C%20data%20insights%2C%20professional%20software%20design%2C%20no%20text%2C%20premium%20minimal%20style&width=800&height=600&seq=astrojal-portfolio-7&orientation=landscape",
    },
  ],
};

export const industriesData = {
  heading: "Technology Solutions Across Industries",
  items: [
    { name: "Healthcare", icon: "ri-hospital-line", desc: "AI-assisted workflows and intelligent applications for modern patient care." },
    { name: "FinTech", icon: "ri-bank-line", desc: "AI-powered analytics, secure transactions and intelligent automation." },
    { name: "E-commerce", icon: "ri-shopping-bag-2-line", desc: "AI recommendations, inventory intelligence and modern shopping experiences." },
    { name: "Education", icon: "ri-graduation-cap-line", desc: "Smart learning platforms and adaptive student engagement tools." },
    { name: "Real Estate", icon: "ri-building-line", desc: "Property tech solutions and intelligent market analytics." },
    { name: "Logistics", icon: "ri-truck-line", desc: "AI-driven route optimization and real-time supply chain tracking." },
    { name: "Travel", icon: "ri-plane-line", desc: "Intelligent booking systems and personalized travel experiences." },
    { name: "SaaS", icon: "ri-cloud-line", desc: "Multi-tenant platforms, AI features and scalable subscriptions." },
    { name: "Enterprise", icon: "ri-building-4-line", desc: "AI workflow automation, business intelligence and custom ERP." },
    { name: "Media & Entertainment", icon: "ri-movie-line", desc: "AI content generation, streaming platforms and digital experiences." },
  ],
};

export const testimonialsData = {
  heading: "What Our Clients Say",
  items: [
    {
      name: "James Mitchell",
      position: "CTO",
      company: "ScaleFlow Inc.",
      rating: 5,
      image:
        "https://readdy.ai/api/search-image?query=Professional%20corporate%20headshot%20portrait%20of%20a%20confident%20man%20in%20his%2040s%20with%20a%20warm%20genuine%20smile%2C%20wearing%20a%20navy%20blazer%20and%20white%20shirt%2C%20clean%20soft%20light-grey%20studio%20background%2C%20natural%20soft%20lighting%2C%20sharp%20focus%20on%20face%2C%20high-quality%20executive%20business%20portrait%20photography&width=400&height=400&seq=astrojal-testi-james&orientation=squarish",
      text: "AstroJal transformed our legacy PHP system into a modern Laravel platform. Their attention to architecture and performance resulted in 3x faster response times and a much more maintainable codebase.",
    },
    {
      name: "Sarah Chen",
      position: "Product Director",
      company: "DataVault Systems",
      rating: 5,
      image:
        "https://readdy.ai/api/search-image?query=Professional%20corporate%20headshot%20portrait%20of%20a%20confident%20professional%20asian%20woman%20with%20a%20warm%20smile%2C%20shoulder-length%20dark%20hair%2C%20wearing%20a%20charcoal%20blazer%2C%20clean%20soft%20light-grey%20studio%20background%2C%20natural%20soft%20lighting%2C%20sharp%20focus%2C%20high-quality%20executive%20business%20portrait%20photography&width=400&height=400&seq=astrojal-testi-sarah&orientation=squarish",
      text: "We needed a complex SaaS platform with multi-tenancy and real-time features. The AstroJal team delivered beyond expectations. Their Laravel expertise is truly world-class.",
    },
    {
      name: "Raj Patel",
      position: "Founder",
      company: "NexGen Health",
      rating: 5,
      image:
        "https://readdy.ai/api/search-image?query=Professional%20corporate%20headshot%20portrait%20of%20a%20confident%20south-asian%20man%20with%20a%20warm%20smile%2C%20short%20dark%20hair%2C%20wearing%20a%20grey%20suit%20jacket%20and%20light%20shirt%2C%20clean%20soft%20light-grey%20studio%20background%2C%20natural%20soft%20lighting%2C%20sharp%20focus%2C%20high-quality%20executive%20business%20portrait%20photography&width=400&height=400&seq=astrojal-testi-raj&orientation=squarish",
      text: "From the first discovery call to post-launch support, AstroJal demonstrated exceptional professionalism. They built our healthcare platform on time, on budget, and with outstanding code quality.",
    },
    {
      name: "Emily Watson",
      position: "Head of Engineering",
      company: "CloudPeak Solutions",
      rating: 5,
      image:
        "https://readdy.ai/api/search-image?query=Professional%20corporate%20headshot%20portrait%20of%20a%20confident%20woman%20with%20a%20warm%20smile%2C%20blonde%20hair%20tied%20back%2C%20wearing%20a%20navy%20blazer%2C%20clean%20soft%20light-grey%20studio%20background%2C%20natural%20soft%20lighting%2C%20sharp%20focus%2C%20high-quality%20executive%20business%20portrait%20photography&width=400&height=400&seq=astrojal-testi-emily&orientation=squarish",
      text: "The API architecture AstroJal designed for our mobile ecosystem is elegant and incredibly fast. Their understanding of Laravel, caching and queue systems is remarkable.",
    },
    {
      name: "Michael Torres",
      position: "CEO",
      company: "FinEdge Technologies",
      rating: 5,
      image:
        "https://readdy.ai/api/search-image?query=Professional%20corporate%20headshot%20portrait%20of%20a%20confident%20hispanic%20man%20with%20a%20warm%20smile%2C%20short%20hair%20and%20light%20beard%2C%20wearing%20a%20dark%20suit%20and%20white%20shirt%2C%20clean%20soft%20light-grey%20studio%20background%2C%20natural%20soft%20lighting%2C%20sharp%20focus%2C%20high-quality%20executive%20business%20portrait%20photography&width=400&height=400&seq=astrojal-testi-michael&orientation=squarish",
      text: "Security and performance were non-negotiable for our financial platform. AstroJal delivered both with flying colors. I would recommend them to anyone serious about quality software.",
    },
    {
      name: "Priya Sharma",
      position: "VP of Technology",
      company: "EduNext Global",
      rating: 5,
      image:
        "https://readdy.ai/api/search-image?query=Professional%20corporate%20headshot%20portrait%20of%20a%20confident%20indian%20woman%20with%20a%20warm%20smile%2C%20long%20dark%20hair%2C%20wearing%20a%20charcoal%20blazer%20over%20a%20blouse%2C%20clean%20soft%20light-grey%20studio%20background%2C%20natural%20soft%20lighting%2C%20sharp%20focus%2C%20high-quality%20executive%20business%20portrait%20photography&width=400&height=400&seq=astrojal-testi-priya&orientation=squarish",
      text: "AstroJal built our education platform from scratch using Laravel. The code quality, testing coverage and documentation were outstanding. A truly professional team.",
    },
  ],
};

export const faqData = {
  heading: "Frequently Asked Questions",
  items: [
    {
      q: "Why should I choose Laravel for my application?",
      a: "Laravel offers an elegant syntax, robust ecosystem, built-in security features, and excellent scalability. It reduces development time while maintaining high code quality, making it ideal for everything from MVPs to enterprise applications.",
    },
    {
      q: "How much does Laravel development cost?",
      a: "Project costs depend on scope, complexity, and timeline. We offer flexible engagement models including fixed-price projects, dedicated teams, and hourly consulting. Contact us for a detailed estimate tailored to your requirements.",
    },
    {
      q: "Can you build a complete SaaS platform using Laravel?",
      a: "Absolutely. We have extensive experience building multi-tenant SaaS platforms using Laravel with features like subscription billing, role-based access, API integrations, and scalable cloud infrastructure.",
    },
    {
      q: "Can you develop APIs for mobile applications?",
      a: "Yes. We design and build RESTful APIs optimized for mobile consumption, with authentication, rate limiting, caching, and comprehensive documentation using tools like Swagger and Postman.",
    },
    {
      q: "Can you migrate an existing PHP application to Laravel?",
      a: "Yes. We have successfully migrated legacy PHP, CodeIgniter, and custom frameworks to Laravel. Our migration process ensures zero data loss and minimal downtime.",
    },
    {
      q: "Can you optimize an existing Laravel application?",
      a: "Yes. We perform comprehensive audits covering database queries, caching strategies, queue processing, front-end assets, and server configuration to dramatically improve performance.",
    },
    {
      q: "Do you provide Laravel maintenance and support?",
      a: "We offer flexible maintenance packages including security updates, bug fixes, performance monitoring, feature enhancements, and 24/7 emergency support.",
    },
    {
      q: "Can you deploy Laravel applications to AWS?",
      a: "Yes. We specialize in AWS deployments using ECS, EC2, RDS, ElastiCache, S3, and CloudFront. We also implement CI/CD pipelines, auto-scaling, and monitoring with CloudWatch.",
    },
    {
      q: "How long does a Laravel project take?",
      a: "A typical MVP takes 6-12 weeks, while enterprise applications may take 3-6 months. We follow agile methodology with two-week sprints and regular deliverables.",
    },
  ],
};

export const clientFirstData = {
  heading: "Technology That Solves Real Business Problems",
  items: [
    {
      title: "Business Understanding",
      desc: "We understand your business before writing code. Our discovery process ensures every feature we build directly supports your goals.",
      icon: "ri-briefcase-line",
    },
    {
      title: "Engineering Excellence",
      desc: "We build secure, maintainable and scalable software. Clean architecture, comprehensive testing, and best practices are non-negotiable.",
      icon: "ri-shield-check-line",
    },
    {
      title: "Long-Term Growth",
      desc: "We create technology that can evolve with your business. Scalable systems designed for future expansion and changing requirements.",
      icon: "ri-line-chart-line",
    },
  ],
};

export const engagementModelsData = {
  heading: "Flexible Ways to Work With Us",
  cta: "Discuss Your Project",
  items: [
    {
      title: "Project-Based Development",
      desc: "Best for clearly defined software projects with specific scope, timeline and deliverables. Fixed-price or milestone-based billing.",
      icon: "ri-folder-line",
      highlight: "Fixed Scope",
    },
    {
      title: "Dedicated Laravel Developer",
      desc: "Best for companies that need an experienced developer or long-term technical resource. Monthly retainer with flexible hours.",
      icon: "ri-user-star-line",
      highlight: "Monthly",
    },
    {
      title: "Dedicated Development Team",
      desc: "Best for startups and businesses building complex digital products. A full team working exclusively on your project.",
      icon: "ri-team-line",
      highlight: "Full Team",
    },
  ],
};

export const securityData = {
  heading: "Built for Security, Performance & Scale",
  items: [
    { title: "Secure Architecture", icon: "ri-lock-2-line" },
    { title: "Optimized Database", icon: "ri-database-2-line" },
    { title: "Fast APIs", icon: "ri-flashlight-line" },
    { title: "Caching & Redis", icon: "ri-server-line" },
    { title: "Cloud Infrastructure", icon: "ri-cloud-line" },
    { title: "Monitoring", icon: "ri-pulse-line" },
    { title: "Backups", icon: "ri-hard-drive-3-line" },
    { title: "Scalable Architecture", icon: "ri-expand-diagonal-line" },
  ],
};

export const ctaData = {
  heading: "Let's Build Something That Scales",
  text: "Have an idea, an existing application or a complex Laravel project? Talk to our experts and let's turn your requirements into a reliable digital product.",
  subtext: "From Laravel applications to AI-powered digital products, we build technology designed for real business growth.",
  primaryCTA: "Start Your Project",
  secondaryCTA: "Talk to a Laravel Expert",
};

export const footerData = {
  company: [
    { label: "About Us", href: "/about-us" },
    { label: "Careers", href: "/careers" },
    { label: "Contact Us", href: "/contact-us" },
  ],
  services: [
    { label: "Laravel Development", href: "/services/laravel-development" },
    { label: "Web Development", href: "/services/web-development" },
    { label: "Mobile Development", href: "/services/mobile-app-development" },
    { label: "AI Development", href: "/services/ai-development" },
    { label: "API Development", href: "/services/api-development" },
    { label: "SaaS Development", href: "/services/saas-development" },
    { label: "Cloud & DevOps", href: "/services/cloud-devops" },
    { label: "UI/UX Design", href: "/services/ui-ux-design" },
    { label: "Maintenance & Support", href: "/services/maintenance-support" },
  ],
  solutions: [
    { label: "Startup Solutions", href: "/solutions" },
    { label: "Business Solutions", href: "/solutions" },
    { label: "Enterprise Solutions", href: "/solutions" },
    { label: "AI Solutions", href: "/ai-solutions" },
    { label: "Dedicated Developers", href: "/hire-laravel-developer" },
  ],
  industries: [
    { label: "Healthcare", href: "/industries/healthcare" },
    { label: "FinTech", href: "/industries/fintech" },
    { label: "E-commerce", href: "/industries/ecommerce" },
    { label: "Education", href: "/industries/education" },
    { label: "Real Estate", href: "/industries/real-estate" },
    { label: "Logistics", href: "/industries/logistics" },
    { label: "Travel", href: "/industries/travel" },
    { label: "SaaS", href: "/industries/saas" },
  ],
  resources: [
    { label: "Portfolio", href: "/portfolio" },
    { label: "Case Studies", href: "/portfolio" },
    { label: "Blog", href: "/blog" },
    { label: "Technologies", href: "/technologies" },
    { label: "Our Process", href: "/process" },
    { label: "FAQ", href: "/faq" },
  ],
  contact: {
    email: "info@astrojal.com",
    phone: "099985 62168",
    address: "308, 3rd Floor, Fortune Plaza, Nr Govardhan Galaxy Bunglows, Fortune Circle, New Naroda, Nikol, Ahmedabad, Gujarat 382330",
    website: "https://astrojal.com",
  },
  social: [
    { label: "LinkedIn", icon: "ri-linkedin-fill", href: "https://in.linkedin.com/company/astrojal-technology" },
    { label: "Facebook", icon: "ri-facebook-fill", href: "https://www.facebook.com/astrojaltechnologies" },
    { label: "Instagram", icon: "ri-instagram-line", href: "https://www.instagram.com/astrojaltechnology/" },
    { label: "X", icon: "ri-twitter-x-line", href: "https://x.com/astrojal" },
    { label: "YouTube", icon: "ri-youtube-fill", href: "https://www.youtube.com/@astrojaltechnology" },
  ],
};

export const certificationsData = [
  {
    name: "ISO 27001 Certified",
    description: "Information Security Management",
    icon: "ri-shield-check-line",
    color: "bg-emerald-500/10 text-emerald-400 border-emerald-500/20",
    checkColor: "text-emerald-400",
  },
  {
    name: "CMMI Level 3 Certified",
    description: "Capability Maturity Model",
    icon: "ri-award-line",
    color: "bg-amber-500/10 text-amber-400 border-amber-500/20",
    checkColor: "text-emerald-400",
  },
  {
    name: "Laravel Certified Partner",
    description: "Official Technology Partner",
    logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/laravel/laravel-original.svg",
    color: "bg-orange-500/10 text-orange-400 border-orange-500/20",
    checkColor: "text-emerald-400",
  },
];

export const awardsData = [
  {
    name: "GoodFirms",
    subtitle: "Top Rated Developer",
    color: "bg-[#2E7CE6]",
    textColor: "text-white",
    icon: "ri-star-fill",
  },
  {
    name: "Freelancer",
    subtitle: "Preferred Partner",
    color: "bg-[#29B2FE]",
    textColor: "text-white",
    icon: "ri-send-plane-fill",
  },
  {
    name: "PeoplePerHour",
    subtitle: "Top App Developer",
    color: "bg-[#EE7203]",
    textColor: "text-white",
    icon: "ri-user-star-line",
  },
  {
    name: "Upwork",
    subtitle: "Top Rated Plus",
    color: "bg-[#6FDA44]",
    textColor: "text-white",
    icon: "ri-briefcase-4-line",
  },
  {
    name: "App Development",
    subtitle: "Certified Agency",
    color: "bg-[#FF6D00]",
    textColor: "text-white",
    icon: "ri-smartphone-line",
  },
  {
    name: "Clutch",
    subtitle: "Top B2B Company",
    color: "bg-[#1A2B3C]",
    textColor: "text-white",
    icon: "ri-circle-fill",
  },
];